export const coversAllUserStores = (flowStores: { id: number }[], userStoreIds: number[]): boolean => {
  if (!userStoreIds.length) return false
  const flowIds = new Set(flowStores.map((s) => s.id))
  return userStoreIds.every((id) => flowIds.has(id))
}
